/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Add_Marker_LabelInputs */



/**
* | output |
* | --- |
* | "Add new marker" |
*
* @param {Markers_Add_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_add_marker_label = /** @type {((inputs?: Markers_Add_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Add_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un nouveau marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Marker hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi nuovo marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить новый маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir nuevo marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいマーカーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मार्कर जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo marcador")
	return /** @type {LocalizedString} */ ("Add new marker")
});